/* eslint-disable react/jsx-props-no-spreading */
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import type { AvailableRoutineItem } from "../types/api-types";

interface RoutineFormDialogProps {
  open: boolean;
  selectedRoutineId: number | null;
  availableOptions: AvailableRoutineItem[];
  allAvailableRoutines: AvailableRoutineItem[] | undefined;
  isSaving: boolean;
  onClose: () => void;
  onSave: () => void;
  onRoutineChange: (routineId: number | null) => void;
}

const RoutineFormDialog = ({
  open,
  selectedRoutineId,
  availableOptions,
  allAvailableRoutines,
  isSaving,
  onClose,
  onSave,
  onRoutineChange,
}: RoutineFormDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Routine</DialogTitle>
      <DialogContent>
        <Autocomplete
          options={availableOptions}
          getOptionLabel={(option) => option.storedProcedure}
          value={
            allAvailableRoutines?.find((r) => r.id === selectedRoutineId) ||
            null
          }
          onChange={(_e, newValue) => onRoutineChange(newValue?.id ?? null)}
          renderInput={(params) => (
            <TextField
              {...params}
              autoFocus
              margin="dense"
              label="Select Routine"
              placeholder="Select a routine"
              helperText="Choose a routine from the list"
            />
          )}
          fullWidth
          disabled={isSaving}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined" disabled={isSaving}>
          Cancel
        </Button>
        <Button
          onClick={onSave}
          variant="contained"
          disabled={selectedRoutineId === null || isSaving}
        >
          {isSaving ? <CircularProgress size={20} /> : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RoutineFormDialog;
